// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tfG0","footer":"styles_footer__3SCiu","passCodeTooltip":"styles_passCodeTooltip__3jDft"};